import { USER_ROLES } from '../interfaces/users.interface';

export interface StatusActor {
	id?: string;
	role?: string;
}

/**
 * Pure gating predicate for status-change buttons (Activar/Desactivar/Bloquear).
 * Mirrors the backend authorization rules so the actor is never offered an
 * action the API will reject with 403. See spec: "Button Visibility Gating".
 *
 * Hidden when: no actor/target · actor targets themself · target is
 * SUPERADMIN · an ADMIN actor targets another ADMIN or a SUPERADMIN.
 */
export function canChangeUserStatus(
	actor: StatusActor | null | undefined,
	targetId?: string,
	targetRole?: string
): boolean {
	if (!actor || !targetId) {
		return false;
	}

	if (actor.id === targetId) {
		return false;
	}

	if (targetRole === USER_ROLES.SUPERADMIN) {
		return false;
	}

	if (
		actor.role === USER_ROLES.ADMIN &&
		(targetRole === USER_ROLES.ADMIN || targetRole === USER_ROLES.SUPERADMIN)
	) {
		return false;
	}

	return true;
}
